import React, { useMemo } from 'react';

import Box from '@mui/material/Box';
import { Avatar, Button, Menu, useMediaQuery } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import { useTranslation } from 'react-i18next';
import { get } from 'lodash';
import { useNavigate } from 'react-router-dom';

import AuthService from 'src/_services/AuthService';
import generateCloudinaryLink from 'src/_utils/generateCloudinaryLink';
import { ROLE_PATH } from 'src/constants';

import { User, Login } from '../../assets';
import MenuLinkWithIcon from '../MenuLinkWithIcon';
import { Register, Login as LoginBlue } from './assets';

const AuthMenu = ({ reload = true, ...props }) => {

    const { t, i18n } = useTranslation('public');
    const navigate = useNavigate();

    const [anchorElLocalization, setAnchorElLocalization] = React.useState(null);
    const handleOpenLocalizationMenu = event => {
        isTokenExist
            ? navigate(`/${get(ROLE_PATH, currentUser?.role)}`)
            : setAnchorElLocalization(event.currentTarget)

    };
    const handleCloseLocalizationMenu = () => setAnchorElLocalization(null);

    const isDownSm = useMediaQuery(theme => theme.breakpoints.down('sm'));

    let isTokenExist = localStorage.getItem("token")
    let currentUser = AuthService.getCurrentUser();

    const AvatarLogo = useMemo(() => {
        if (isTokenExist) {
            if (!!currentUser?.merchant?.logo) {
                return generateCloudinaryLink(currentUser?.merchant?.logo)
            }
            return User
        } else {
            return Login
        }
    }, [isTokenExist, currentUser])

    return (
        <Box {...props}>
            {
                isTokenExist ?
                    <Button disableRipple color="white" onClick={handleOpenLocalizationMenu} >
                        {/* <Avatar
                    sx={{
                        width: isDownSm ? "40px" : '44px',
                        height: isDownSm ? "40px" : '44px',
                        padding: '12px',
                        backgroundColor: '#0B6296',
                        transform: i18n.dir() === "rtl" ? 'scaleX(-1)' : undefined
                    }}
                    src={AvatarLogo}
                /> */}
                        {t("Dashboard")}
                    </Button>
                    :
                    <Button color="white" sx={{ textTransform: "none" }} onClick={() => navigate('/auth/general')}>
                        {t("Login")}
                    </Button>
            }
            {/* <Menu
                sx={{ mt: {xs: '80px', md: '55px'} }}
                id="menu-appbar"
                anchorEl={anchorElLocalization}
                anchorOrigin={{ vertical: 'bottom', horizontal: i18n.dir() === "rtl" ? 'center' : 'center' }}
                keepMounted
                transformOrigin={{ vertical: 'bottom', horizontal: i18n.dir() === "rtl" ? 'center' : 'center' }}
                open={Boolean(anchorElLocalization)}
                onClose={handleCloseLocalizationMenu}
            >
                <Box sx={{ paddingInlineStart: 4, paddingInlineEnd: 6, paddingBlock: 2 }}>
                    <MenuLinkWithIcon link={{
                        icon: LoginBlue,
                        title: t("login.login", { ns: "auth" }),
                        href: "/auth/general"
                    }} sx={{ marginBlock: 2 }} />
                    <MenuLinkWithIcon link={{
                        icon: Register,
                        title: t("login.createAccount", { ns: "auth" }),
                        href: "/auth/general/register"
                    }} sx={{ marginBlock: 2 }} />
                </Box>
            </Menu> */}
        </Box>
    );
}

export default AuthMenu;

// {/* <IconButton
//     disableRipple
//     sx={{ p: 1, ':hover': { backgroundColor: 'transparent !important' }, display: 'inline-block' }}
//     href={isTokenExist ? `/${get(ROLE_PATH, currentUser?.role)}` : '/auth/general'}
// >
//     <Tooltip placement='top' title={isTokenExist ? t("Dashboard", { ns: "main" }) : t("Log In", { ns: "main" })}>
//         <Avatar
//             sx={{
//                 width: isDownSm ? "40px" : '44px',
//                 height: isDownSm ? "40px" : '44px',
//                 padding: '12px',
//                 backgroundColor: '#0B6296',
//                 transform: i18n.dir() === "rtl" ? 'scaleX(-1)' : undefined
//             }}
//             src={AvatarLogo}
//         />
//     </Tooltip>
// </IconButton> */}